import { Stack } from '@startuptools/ui/Stack';
import { Typography } from '@startuptools/ui/Typography';
import { useTheme } from '@startuptools/ui/Theme';
import useMediaQuery from '@mui/material/useMediaQuery';

export const MainHeader = ({
  headerText,
  subHeaderText,
  alignItems = 'flex-start',
  paddingTop,
  paddingLeft,
  textAlign = 'start',
}: {
  headerText: string;
  subHeaderText: string;
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'baseline' | 'stretch';
  paddingTop: number | string;
  paddingLeft: number | string;
  textAlign: 'left' | 'right' | 'center' | 'justify' | 'inherit' | 'start';
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const paddingTopValue = typeof paddingTop === 'number' ? `${paddingTop}rem` : paddingTop;
  const paddingLeftValue = typeof paddingLeft === 'number' ? `${paddingLeft}rem` : paddingLeft;

  return (
    <Stack
      sx={{
        maxWidth: '100%',
        width: isMobile ? '90%' : 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: alignItems,
        paddingTop: paddingTopValue,
        paddingLeft: paddingLeftValue,
        gap: 2,
        overflow: 'hidden',
      }}
      spacing={2}
    >
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontStyle: 'normal',
          fontWeight: 400,
          fontSize: '1rem',
          lineHeight: '1.5rem',
          textAlign: textAlign,
        }}
        level="body-lg"
      >
        {headerText}
      </Typography>
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontStyle: 'normal',
          fontWeight: 700,
          fontSize: '2rem',
          lineHeight: '2.0625rem',
          textAlign: textAlign,
        }}
        level="h2"
      >
        {subHeaderText}
      </Typography>
    </Stack>
  );
};
